<template>
    <div>
         <template>
            <template v-if="setTableData().toString()===''">
                <span>{{row[col.key]}}</span>
            </template>
            <template v-else>
                <Tabletip :width="editCfg.width" :columns="editCfg.columns" :tableData="setTableData()" :padding="editCfg.padding" :trigger="editCfg.trigger" theme="light">
                    <span >{{row[col.key]}}</span>
                </Tabletip>
            </template>
        </template>
    </div>
</template>
<script>
    import Tabletip from '../../tabletip/tabletip.vue';
    export default{
        name:"plugtabletip",
        components: { Tabletip },
        props:{
            col: [String, Number, Object],
            row: [String, Number, Object],
            editCfg: Object
        },
        methods:{
            setTableData(){
                let row=this.row;
                return this.editCfg.setTableData(row) || [];
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/table/plug/tableTip.vue